<template>
  <div class="camera-wrapper">

    <!-- Câmera + Canvas -->
    <div class="camera-container">
      <video
        ref="camera"
        autoplay
        playsinline
        :class="{ oculto: !exibirCamera }"
      ></video>

      <canvas
        ref="canvas"
        :width="camWidth"
        :height="camHeight"
        :class="{ oculto: exibirCamera }"
      ></canvas>
    </div>

    <!-- Botões -->
    <div class="buttons-container">
      <Button
        label="Foto"
        icon="pi pi-camera"
        :disabled="!cameraPronta"
        @click="capturarImagem"
      />

      <Button
        v-if="!exibirCamera"
        label="Descartar"
        icon="pi pi-trash"
        class="p-button-danger p-ml-2"
        @click="descartar"
      />
    </div>

  </div>
</template>


<script>
export default {
  props: {
      controlarBotaoSalvar: {
          type: Function,
          required: false,
      }
  },
  data() {
    return {
      exibirCamera: true,
      cameraPronta: false,
      camWidth: 640,
      camHeight: 480,
      stream: null,
      dadosImagem: { blobURL: "", base64: "" },
    };
  },

  methods: {
    async ligarCamera() {
      if(this.controlarBotaoSalvar) {
        const bloquear = true;
        this.controlarBotaoSalvar(bloquear);
      }
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: {
            width: this.camWidth,
            height: this.camHeight,
            facingMode: "user"
          },
          audio: false
        });

        const video = this.$refs.camera;
        video.srcObject = this.stream;

        // Aguarda o vídeo carregar os metadados
        await new Promise(resolve => {
          video.onloadedmetadata = () => resolve();
        });

        // Aguarda o vídeo realmente começar a reproduzir frames
        await video.play();

        // Só agora consideramos a câmera pronta
        this.cameraPronta = true;        

      } catch (erro) {
        console.error("Erro ao acessar webcam:", erro);
      }
    },

    capturarImagem() {
      if (!this.cameraPronta) return;

      const video = this.$refs.camera;
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext("2d");

      // Garante que existe frame disponível
      if (video.readyState < 2) {
        console.warn("Frame não está pronto ainda");
        return;
      }

      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      this.exibirCamera = false;
      if(this.controlarBotaoSalvar) {
        const bloquear = false;
        this.controlarBotaoSalvar(bloquear);
      }
    },

    capturarImagemBase64() {
      return new Promise(resolve => {
        const dataURL = this.$refs.canvas.toDataURL("image/jpeg", 0.95);
        this.dadosImagem.base64 = dataURL;        
        resolve({ ...this.dadosImagem });
      });
    },

    descartar() {
      const ctx = this.$refs.canvas.getContext("2d");
      ctx.clearRect(0, 0, this.camWidth, this.camHeight);
      this.exibirCamera = true;
      if(this.controlarBotaoSalvar) {
        const bloquear = true;
        this.controlarBotaoSalvar(bloquear);
      }
    },

    desligarCamera() {
      if (!this.stream) return;
      this.stream.getTracks().forEach(t => t.stop());
      this.stream = null;
      this.cameraPronta = false;
    }
  },

  mounted() {
    this.ligarCamera();
  },

  beforeDestroy() {
    this.desligarCamera();
  }
};
</script>

<style scoped>
.camera-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center; /* Mantém a câmera centralizada */
}

.camera-container {
  position: relative;
  width: 640px;
  height: 480px;
  margin-bottom: 1rem;
}

.camera-container video,
.camera-container canvas {
  position: absolute;
  top: 0;
  left: 0;
}

.oculto {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

/* Botões alinhados à esquerda */
.buttons-container {
  display: flex;
  justify-content: flex-start; /* ALINHA À ESQUERDA */
  width: 640px; /* Mesma largura da câmera para manter alinhamento */
  margin-top: 0.5rem;
}

</style>
